import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_button = _resolveComponent("f-button")!

  return (_openBlock(), _createBlock(_component_f_button, {
    class: "common-btn",
    disabled: _ctx.disabled,
    text: "Button",
    type: _ctx.type,
    danger: _ctx.isDanger,
    small: _ctx.isSmall,
    onClick: _ctx.handleClick
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "icon", {}, undefined, true),
      _createTextVNode(" " + _toDisplayString(`${_ctx.text}`), 1)
    ]),
    _: 3
  }, 8, ["disabled", "type", "danger", "small", "onClick"]))
}